angular
	.module 'App.Filter'
	.filter 'date', (DateService) ->
		return (timestamp, showTime = true) ->
			return DateService.format(timestamp, showTime)
